import React, { Component } from 'react';
import { history } from 'components/App/components/UnauthenticatedApp';
import { connect } from 'react-redux';
import './Agenda.module.scss';
import Modal from 'react-responsive-modal';
import customIsoString from 'utilities/custom-iso-string';
import { DragDropContext } from 'react-beautiful-dnd';
import Select from 'react-select';

/**
 * Import components
 */
import Checkbox from 'components/UI/Checkbox/Checkbox';
import Card from 'components/UI/Card/Card';
import ScheduleSubject from 'components/UI/Popup/ScheduleSubject/ScheduleSubject';
import InputAgendaItem from 'components/UI/Popup/InputAgendaItem/InputAgendaItem';
import AgendaItems from 'components/UI/Popup/AgendaItems/AgendaItems';
import MoveSubject from 'components/UI/Popup/MoveSubject/MoveSubject';
import ClearPopup from 'components/UI/Popup/ClearPopup/ClearPopup';
import DefaultButton from 'components/UI/Button/Button';
import ConflictItem from 'components/UI/ConflictItem/ConflictItem';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Import actions
 */
import { toggleHourVisible, toggleRoomVisible, toggleTeacherVisible, toggleColorVisible } from 'actions/agenda/index.js';
import userSubjectIndex from 'actions/usersubject/index';
import colorIndex from 'actions/color/index';
import homeworkIndex from 'actions/homework/index';
import holidayIndex from 'actions/holiday/index';
import { homeworkUpdateDirectInput, homeworkUpdateDirectInputSwitcher, homeworkReset } from 'actions/new-homework';
import eventIndex from 'actions/event/index';
import updateEvent from 'actions/event/update';
import indexTask from 'actions/task/index';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

const valueFromLabel = (opts, label) => opts.find(o => o.label === label);
const valueFromValue = (opts, value) => opts.find(o => o.value === value);

const mapStateToProps = (state, props) => {
    return {
        agendaVisibility: state.agenda,
        new_homework: state.new_homework,
        user: state.authentication.user,
        events: state.event.entities,
        conflicts: state.conflict.entities
    };
};

const mapDispatchToProps = {
    toggleHourVisible,
    toggleRoomVisible,
    toggleTeacherVisible,
    toggleColorVisible,
    userSubjectIndex,
    colorIndex,
    homeworkIndex,
    homeworkUpdateDirectInput,
    homeworkUpdateDirectInputSwitcher,
    homeworkReset,
    holidayIndex,
    eventIndex,
    updateEvent,
    indexTask
};

const customStyles1 = {
    container: styles => ({ 
        ...styles, 
        width: '90px'
    }),
    control: styles => ({ 
        ...styles, 
        fontSize: '12px',
        marginRight: '10px',
        height: '49px'
    }),
    option: styles => ({
        ...styles,
        fontSize: '12px',
    })
};
const customStyles2 = {
    container: styles => ({ 
        ...styles, 
        width: '140px'
    }),
    control: styles => ({ 
        ...styles, 
        fontSize: '12px',
        marginRight: '10px',
        height: '49px'
    }),
    option: styles => ({
        ...styles,
        fontSize: '12px',
    })
};
const customStyles3 = {
    container: styles => ({ 
        ...styles, 
        width: '90px'
    }),
    control: styles => ({ 
        ...styles, 
        fontSize: '12px',
        marginRight: '10px',
        height: '49px'
    }),
    option: styles => ({
        ...styles,
        fontSize: '12px',
    })
};

const months = [
    {
        label: 'Januari',
        value: 1
    },
    {
        label: 'Februari',
        value: 2
    },
    {
        label: 'Maart',
        value: 3
    },
    {
        label: 'April',
        value: 4
    },
    {
        label: 'Mei',
        value: 5
    },
    {
        label: 'Juni',
        value: 6
    },
    {
        label: 'Juli',
        value: 7
    },
    {
        label: 'Augustus',
        value: 8
    },
    {
        label: 'September',
        value: 9
    },
    {
        label: 'Oktober',
        value: 10
    },
    {
        label: 'November',
        value: 11
    },
    {
        label: 'December',
        value: 12
    }
];

const years = [
    {
        label: '2020',
        value: 2020,
    },
    {
        label: '2021',
        value: 2021,
    },
    {
        label: '2022',
        value: 2022,
    },
    {
        label: '2023',
        value: 2023,
    },
    {
        label: '2024',
        value: 2024,
    },
    {
        label: '2025',
        value: 2025,
    },
    {
        label: '2026',
        value: 2026,
    },
];


let totalScroll = 0;


class Agenda extends Component {
    constructor() {
        super();

        this.state = {
            showMenu: false,
            showInput: false,
            showInputHomework: false,
            scheduleSubject: false,
            showPopup: false,
            draggingASchedule: false,
            showConflictPopup: false,
            showCalendarPopup: false,
            showSubjectMovedPopup: false,
            moveSubjectData: {},
            showAgendaItemPopup: false,
            showClearPopup: false,
            clearType: null,
            clearDate: '',
            day: null,
            month: null,
            year: null,
            testValue: '20'
        };

        this.toggleHourVisible          = this.toggleHourVisible.bind(this);
        this.toggleTeacherVisible       = this.toggleTeacherVisible.bind(this);
        this.toggleRoomVisible          = this.toggleRoomVisible.bind(this);
        this.switchMenu                 = this.switchMenu.bind(this);
        this.toggleColorVisible         = this.toggleColorVisible.bind(this);
        this.handleToggle               = this.handleToggle.bind(this);
        this.moveLeft                   = this.moveLeft.bind(this);
        this.moveRight                  = this.moveRight.bind(this);
        this.sideScroll                 = this.sideScroll.bind(this);
        this.togglePopup                = this.togglePopup.bind(this);
        this.setWrapperRef              = this.setWrapperRef.bind(this);
        this.setCalendarWrapperRef      = this.setCalendarWrapperRef.bind(this);
        this.handleClickOutside         = this.handleClickOutside.bind(this);
        this.onDragStart                = this.onDragStart.bind(this);
        this.onDragEnd                  = this.onDragEnd.bind(this);
        this.openScheduleSubject        = this.openScheduleSubject.bind(this);
        this.toggleScheduleSubject      = this.toggleScheduleSubject.bind(this);
        this.toggleConflictPopup        = this.toggleConflictPopup.bind(this);
        this.setConflictWrapperRef      = this.setConflictWrapperRef.bind(this);
        this.toggleCalendarPopup        = this.toggleCalendarPopup.bind(this);
        this.closeSubjectMovedPopup     = this.closeSubjectMovedPopup.bind(this);
        this.moveSubject                = this.moveSubject.bind(this);
        this.toggleAgendaItemPopup      = this.toggleAgendaItemPopup.bind(this);
        this.toggleClearPopup           = this.toggleClearPopup.bind(this);
        this.inputAgendaItem            = this.inputAgendaItem.bind(this);
        this.dayValues                  = this.dayValues.bind(this);
        this.setDayValue                = this.setDayValue.bind(this);
        this.setMonthValue              = this.setMonthValue.bind(this);
        this.setYearValue               = this.setYearValue.bind(this);
        this.goToDate                   = this.goToDate.bind(this);
        this.goToProfile                = this.goToProfile.bind(this);
        this.setDayToToday              = this.setDayToToday.bind(this);
        this.handleAgendaItemEdit       = this.handleAgendaItemEdit.bind(this);
    }

    componentDidMount() {
        this.props.userSubjectIndex();
        this.props.colorIndex();
        this.props.homeworkIndex();
        this.props.holidayIndex();

        this.props.eventIndex({});
        this.setDayToToday();

    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setDayToToday() {
        var today = new Date();
        let dayValue = String(today.getDate());
        let monthValue = (today.getMonth()+1);
        let yearValue = String(today.getFullYear());

        this.setState({
            day: dayValue,
            month: monthValue,
            year: yearValue,
        });
    }
    goToProfile() {
        history.push('/profile');
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    setConflictWrapperRef(node) {
        this.conflictWrapperRef = node;
    }

    setCalendarWrapperRef(node) {
        this.calendarWrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && this.state.showPopup && !this.wrapperRef.contains(event.target)) {
            this.setState({
                showPopup: false
            });
            document.removeEventListener('mousedown', this.handleClickOutside);
        }

        if (this.conflictWrapperRef && this.state.showConflictPopup && !this.conflictWrapperRef.contains(event.target)) {
            this.setState({
                showConflictPopup: false
            });
            document.removeEventListener('mousedown', this.handleClickOutside);
        }

        if (this.calendarWrapperRef && this.state.showCalendarPopup && !this.calendarWrapperRef.contains(event.target)) {
            this.setState({
                showCalendarPopup: false
            });
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
    }

    switchMenu(e) {
        e.stopPropagation();
        this.props.switchMenu();
    }

    toggleHourVisible() {
        this.props.toggleHourVisible();
    }

    toggleTeacherVisible() {
        this.props.toggleTeacherVisible();
    }

    toggleRoomVisible() {
        this.props.toggleRoomVisible();
    }

    toggleColorVisible() {
        this.props.toggleColorVisible();
    }

    handleToggle(e) {
        e.stopPropagation();
    }
    // moveLeft() {
    //     var container = document.querySelector('#agenda');
    //     console.warn('Prev: ' + this.props.prevMonday);
    //     this.sideScroll(container, 'left', this.props.prevMonday);

    // }

    // moveRight() {
    //     var container = document.querySelector('#agenda');
    //     console.warn('Next: ' + this.props.nextMonday);
    //     this.sideScroll(container, 'right', );
    // }

    moveLeft() {
        var container = document.querySelector('#agenda');
        // console.warn('Prev: ' + this.props.prevMonday);
        this.sideScroll(container, 'left', 7*204);
    }

    moveRight() {
        var container = document.querySelector('#agenda');
        // console.warn('Next: ' + this.props.nextMonday);
        this.sideScroll(container, 'right', 7*204);
    }

    sideScroll(element, direction, amount) {
        if (direction == 'left') {
            element.scrollLeft -= amount;
        } else {
            element.scrollLeft += amount;
        }
    }

    togglePopup() {
        if (this.state.showPopup) {
            document.removeEventListener('mousedown', this.handleClickOutside);
        } else {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
        this.setState(prevState => {
            return {
                showPopup: !prevState.showPopup
            };
        });
    }

    openScheduleSubject() {
        this.setState({
            scheduleSubject: true
        });
    }

    toggleScheduleSubject() {
        if (this.state.scheduleSubject) {
            this.props.homeworkReset();
        }
        this.setState(prevState => {
            return {
                scheduleSubject: !prevState.scheduleSubject
            };
        });
    }

    toggleConflictPopup() {
        if (this.state.showConflictPopup) {
            document.removeEventListener('mousedown', this.handleClickOutside);
        } else {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
        this.setState(prevState => {
            return {
                showConflictPopup: !prevState.showConflictPopup
            };
        });
    }

    toggleCalendarPopup() {
        if (this.state.showCalendarPopup) {
            document.removeEventListener('mousedown', this.handleClickOutside);
        } else {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
        this.setState(prevState => {
            return {
                showCalendarPopup: !prevState.showCalendarPopup
            };
        });
    }

    closeSubjectMovedPopup() {
        this.setState({ showSubjectMovedPopup: false });
    }

    moveSubject(editMode) {
        this.closeSubjectMovedPopup();
        let moveSubjectData = this.state.moveSubjectData;

        let event = this.props.events.byId[this.state.moveSubjectData.draggableId];

        let newDate = moveSubjectData.destination.droppableId;
        let dateAndTimeslot = newDate.split('empty-')[1];
        newDate = dateAndTimeslot.substring(0, dateAndTimeslot.length - 2); //remove '-X' from string (order)
        let timeslot = dateAndTimeslot.slice(-1);

        this.props.updateEvent({
            ...event,
            startDateUtc: newDate,
            endDateUtc: newDate,
            timeslot: timeslot,
            oldTimeslot: event.timeslot,
            ristart: event.startDateUtc,
            redit: editMode
        }).then((data) => {
            this.props.homeworkIndex();
            this.props.indexTask();
        });

    }

    onDragStart(draggable) {
        let event = this.props.events.byId[draggable.draggableId];
        this.setState({ draggingASchedule: { id: draggable.draggableId, duration: event.duration }}); //store eventID and event duration in state, to pass on to Card
        //set drag status in parent component to disable adding days
        this.props.handleDragUpdate(true);

    }

    onDragEnd(result) {
        const { destination, draggableId } = result;
        this.setState({ draggingASchedule: false });

        //reset drag status in parent component to enable adding days again
        this.props.handleDragUpdate(false);

        if (!destination) {
            return;
        }

        if (!destination.droppableId || !destination.droppableId.startsWith('empty')) {
            return;
        }

        let event = this.props.events.byId[draggableId];

        let newDate = destination.droppableId;
        let dateAndTimeslot = newDate.split('empty-')[1];
        newDate = dateAndTimeslot.substring(0, dateAndTimeslot.length - 2); //remove '-X' from string (order)
        let timeslot = dateAndTimeslot.slice(-1);

        let oldDate = event.startDateUtc.split(' ')[0];
        if (oldDate == newDate && event.timeslot == timeslot) {
            return;
        }

        if (event.isRecurring) {
            this.setState({
                showSubjectMovedPopup: true,
                moveSubjectData: {
                    ...result
                }
            });
        } else {

            this.props.updateEvent({
                ...event,
                startDateUtc: newDate,
                endDateUtc: newDate,
                timeslot: timeslot,
                ristart: event.startDateUtc,
            }).then((data) => {
                this.props.homeworkIndex();
                this.props.indexTask();
            });
        }

    }

    toggleAgendaItemPopup(hasItems) {

        if (this.state.showAgendaItemsPopup || this.state.showNewAgendaItemPopup) {
            this.setState({
                showNewAgendaItemPopup: false,
                showAgendaItemsPopup: false,
                editingAgendaItem: null
            });
        } else {
            if (hasItems) {
                this.setState({
                    showAgendaItemsPopup: true
                });
            } else {
                this.setState({
                    showNewAgendaItemPopup: true
                });
            }
        }

        this.setState(prevState => {
            return {
                showAgendaItemPopup: !prevState.showAgendaItemPopup
            };
        });
    }

    inputAgendaItem() {
        this.setState({
            showNewAgendaItemPopup: true
        });
    }

    toggleClearPopup(type, clearDate) {
 
        this.setState(prevState => {
            return {
                showClearPopup: !prevState.showClearPopup,
                clearType: prevState.showClearPopup === true ? null : type,
                clearDate: prevState.showClearPopup === true ? '' : clearDate
            };
        });
    }

    handleAgendaItemEdit(id) {

        this.setState({
            editingAgendaItem: this.props.events.byId[id],
            showNewAgendaItemPopup: true
        });
    }

    dayValues() {
        const dayValues = [];

        for (let i = 1; i <=31; i++) {
            let tempObject = {
                value: i,
                label: `${i}`
            };
            dayValues.push(tempObject);
        }
        return dayValues;
    }

    setDayValue(day) {
        let value = day.value;
        this.setState({
            day: value
        });
    }

    setMonthValue(month) {
        let value = month.value;
        this.setState({
            month: value
        });
    }

    setYearValue(year) {
        let value = year.value;
        this.setState({
            year: value
        });
    }

    goToDate(date) {

        if (date && typeof date == 'string') {
            return this.props.goToDate(date);
        }

        let monthValue = this.state.month < 10 ? '0' + this.state.month : this.state.month;
        let dayValue = this.state.day < 10 ? '0' + this.state.day : this.state.day;
        let dateString = `${this.state.year}-${monthValue}-${dayValue}`;
        if (!dateString.includes('null')) {
            this.props.goToDate(dateString);
            this.setState({
                showCalendarPopup: false
            });
        }
    }

    render() {

        let sortedConflicts = this.props.conflicts.allIds.map(id => this.props.conflicts.byId[id]);
        sortedConflicts.sort(function(a,b) {
            return new Date(a.date) - new Date(b.date);
        });

        const { showAgenda, switchAgenda, scrollHandler } = this.props;
        const { showPopup, scheduleSubject, showConflictPopup, showCalendarPopup, showNewAgendaItemPopup, showAgendaItemsPopup, showSubjectMovedPopup, showClearPopup, clearType, clearDate } = this.state;

        let cards = [];
        let today;

        if (this.props.centerDay) {
            today = new Date(this.props.centerDay);
        } else {
            today = new Date();
        }

        //create past days
        for (let index = (-1 * this.props.daysPast); index < 0; index++) {
            let currentDate;
            let past;

            if (this.props.centerDay) {
                currentDate = new Date(this.props.centerDay);
                currentDate.setDate(today.getDate()+index);
                currentDate.setHours(22);
                past = new Date() > currentDate;
            } else {
                currentDate = new Date();
                currentDate.setDate(today.getDate()+index);
                past = true;
            }

            cards.push(<Card key={index} 
                date={currentDate}
                past={past}
                draggingASchedule={this.state.draggingASchedule} 
                onAgendaItemClick={this.toggleAgendaItemPopup} 
                handleAgendaInputClick={this.inputAgendaItem}
                onScheduleItemClick={this.toggleScheduleSubject}
                handleClearOptionClick={this.toggleClearPopup}/>);
        }

        //create future days
        for (let index = 0; index < this.props.daysFuture; index++) {
            let currentDate;
            let past;
            if (this.props.centerDay) {
                currentDate = new Date(this.props.centerDay);
                currentDate.setDate(today.getDate()+index);
                currentDate.setHours(22);
                past = new Date() > currentDate;
            } else {
                currentDate = new Date();
                currentDate.setDate(today.getDate()+index);
                past = false;
            }            

            cards.push(<Card key={index} 
                date={currentDate}
                past={past}
                draggingASchedule={this.state.draggingASchedule} 
                onAgendaItemClick={this.toggleAgendaItemPopup} 
                handleAgendaInputClick={this.inputAgendaItem}
                onScheduleItemClick={this.toggleScheduleSubject}
                handleClearOptionClick={this.toggleClearPopup}/>);
        }

        return (
            <div styleName='agenda-background'>
                <Modal open={showClearPopup} onClose={this.toggleClearPopup} center styles={{
                    modal: {
                        borderRadius: '6px',
                        width: '500px',
                        padding: '10px 15px',
                        height: '110px',
                    },
                    closeIcon: {
                        display: 'none'
                    }
                }}>
                    <ClearPopup onClose={this.toggleClearPopup} type={clearType} clearDate={clearDate}/>
                </Modal>
                <Modal open={showSubjectMovedPopup} onClose={this.closeSubjectMovedPopup} center styles={{
                    modal: {
                        borderRadius: '6px',
                        width: '500px',
                        padding: '10px 15px'
                    },
                    closeIcon: {
                        display: 'none'
                    }
                }}>
                    <MoveSubject moveSubject={this.moveSubject} onClose={this.closeSubjectMovedPopup}/>
                </Modal>
                <Modal open={(showAgendaItemsPopup || showNewAgendaItemPopup) ? true : false} onClose={this.toggleAgendaItemPopup} center styles={{
                    modal: {
                        background: 'none',
                        boxShadow: 'none'
                    },
                    closeIcon: {
                        fill: '#fff',
                        cursor: 'pointer'
                    }
                }}>
                    {showNewAgendaItemPopup ? <InputAgendaItem updateAppointment={this.updateAgendaItem} editItem={this.state.editingAgendaItem} handleClose={this.toggleAgendaItemPopup}/> : <AgendaItems handleEdit={this.handleAgendaItemEdit} toggleAgendaItemPopup={this.toggleAgendaItemPopup} handlePlanClick={this.inputAgendaItem}/>}
                </Modal>
                <Modal open={scheduleSubject} onClose={this.toggleScheduleSubject} center styles={{
                    modal: {
                        background: 'none',
                        boxShadow: 'none'
                    },
                    closeIcon: {
                        fill: '#fff',
                        cursor: 'pointer'
                    },
                    overlay: {
                        padding: '0px'
                    }
                }}>
                    <ScheduleSubject onClose={this.toggleScheduleSubject}/>
                </Modal>
                <div id='agenda-fold' styleName='agenda-top'>
                    <div styleName='left'>
                        <div styleName='hamburger' onClick={this.switchMenu}><FontAwesomeIcon icon={[ 'far', 'bars' ]}/></div>
                        <h1 styleName='title-wrapper' onClick={switchAgenda}>Huiswerk & <div styleName='bold'>Agenda <div styleName='fold-button'><FontAwesomeIcon style={ showAgenda ? {transform: 'rotate(180deg)'} : null} icon={faChevronDown}/></div></div></h1>
                    </div>
                    <div styleName={'right'} style={sortedConflicts.length > 0 ? { minWidth: '310px' } : { minWidth: '260px' }}>
                        {sortedConflicts.length > 0 && <div styleName='conflict-button' onClick={this.toggleConflictPopup} ref={this.setConflictWrapperRef}>
                            <DefaultButton normal conflict style={{ visibility: 'visible', width: '50px', height: '30px', borderRadius: '15px', margin: '0 5px 0 0', padding: '0 0', justifyContent: 'space-between' }} title={sortedConflicts.length} />
                            {
                                showConflictPopup &&
                            
                            <div styleName={'conflict-popup'}>
                                <div styleName='arrow-up'/>
                                <div styleName='text'>
                                    <p style={{ fontWeight: '800' }}>Er zijn {sortedConflicts.length} dagen met dubbele afspraken aangetroffen.</p>
                                    <p>Klik op de dag om direct naar het conflict te scrollen.</p>
                                </div>
                                {
                                    sortedConflicts.map((conflict) => (
                                        <ConflictItem key={conflict.id} goToDate={this.goToDate} date={conflict.date} conflictAmount={conflict.count} timeslot={conflict.timeslot}/>
                                    ))
                                }
                            </div>
                            }
                        </div>}
                        <div styleName='navigation-buttons'>
                            <div styleName='arrow' style={{ visibility: 'visible' }} onClick={this.moveLeft}>
                                <FontAwesomeIcon styleName='icon' icon={[ 'far', 'angle-left' ]} />
                            </div>

                            <DefaultButton normal handleClick={this.props.goToToday} textStyle={{ flexDirection: 'row' }} style={{ visibility: 'visible', width: '32px', height: '28px', borderRadius: '5px', margin: '0 5px' }} title={'Vandaag'} />

                            <div styleName='arrow'  style={{ visibility: 'visible' }} onClick={this.moveRight}>
                                <FontAwesomeIcon styleName='icon' icon={[ 'far', 'angle-right' ]} />
                            </div>                            
                        </div>
                        <div styleName="calendar-button" style={{ visibility: 'visible' }} ref={this.setCalendarWrapperRef}>
                            
                            <FontAwesomeIcon styleName='icon' icon={[ 'far', 'calendar' ]} onClick={this.toggleCalendarPopup} />
                            
                            <div styleName={`calendar-popup ${showCalendarPopup ? '' : 'hidden'}`}>
                                <div styleName='arrow-up'/>
                                <div styleName='dropdown-wrapper'>
                                    <Select
                                        onChange={this.setDayValue}
                                        value={valueFromLabel(this.dayValues(), this.state.day)}
                                        options={this.dayValues()}
                                        styles={customStyles3} 
                                        placeholder={'Dag'}
                                        isSearchable={false}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                    />
                                    <Select
                                        onChange={this.setMonthValue}
                                        value={valueFromValue(months, this.state.month)}
                                        options={months}
                                        styles={customStyles2} 
                                        placeholder={'Maand'}
                                        isSearchable={false}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                    />
                                    <Select
                                        onChange={this.setYearValue}
                                        value={valueFromLabel(years, this.state.year)}
                                        options={years}
                                        styles={customStyles1} 
                                        placeholder={'Jaar'}
                                        isSearchable={false}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                    />
                                    <FontAwesomeIcon styleName='forward-icon' icon={[ 'fal', 'angle-right' ]} onClick={this.goToDate}/>
                                </div>
                            </div>

                        </div>
                        <div styleName="circle" style={{ visibility: 'visible' }} onClick={this.togglePopup} ref={this.setWrapperRef}>
                            <div styleName="plus">
                                <FontAwesomeIcon styleName='icon' icon={[ 'far', 'ellipsis-h' ]}/>
                            </div>
                            <div styleName={`popup ${showPopup ? '' : 'hidden'}`}>
                                <div styleName={`checkboxes ${showAgenda ? 'visible' : ''}`}>
                                    <Checkbox hoverCheck style={{ justifyContent: 'flex-start', height: '17px', paddingLeft: '10px' }} handleClick={this.toggleHourVisible} checked={this.props.agendaVisibility.hour} label='Uur'/>
                                    <Checkbox hoverCheck style={{ justifyContent: 'flex-start', height: '17px', paddingLeft: '10px' }} handleClick={this.toggleTeacherVisible} checked={this.props.agendaVisibility.teacher} label='Docent'/>
                                    <Checkbox hoverCheck style={{ justifyContent: 'flex-start', height: '17px', paddingLeft: '10px' }} handleClick={this.toggleRoomVisible} checked={this.props.agendaVisibility.room} label='Lokaal'/>
                                    <Checkbox hoverCheck style={{ justifyContent: 'flex-start', height: '17px', paddingLeft: '10px' }} handleClick={this.toggleColorVisible} checked={this.props.agendaVisibility.color} label='Vakkleuren'/>
                                </div>
                            </div>
                        </div>

                        <div styleName="circle name" onClick={this.goToProfile} style={{ visibility: 'visible' }}>
                            <div styleName="plus">
                                {this.props.initials}
                            </div>
                        </div>
                    </div>
                </div>
                <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
                    <div id='agenda' onScroll={() => scrollHandler && scrollHandler('Agenda')} styleName={'agenda ' + (showAgenda ? 'visible' : '')} >
                        {
                            cards
                        }
                    </div>
                </DragDropContext>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Agenda);
